<template>
  <v-app style="background-color: #f8f7f4;">
    <Navbar
      v-if="!['landingpage', 'login', 'register', 'register-public', 'verify-email', 'GraphAnalysisFullScreen'].includes($route.name)"
      @updateNavbarWithName="updateNavbarWithName"
    />
    <v-content
      :class="{ 'mx-4': !['Generative AI', 'landingpage', 'login', 'register', 'register-public'].includes($route.name) }"
      :style="{
        backgroundColor: $route.name == 'Generative AI' ? '#fff' : '#f8f7f4',
        marginBottom: ['landingpage', 'login', 'register', 'register-public'].includes($route.name) ? '0px' : '66px',
      }"
    >
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import { mapMutations } from 'vuex';
export default {
  name: 'App',
  components: {
    Navbar
  },
  data () {
    return {
      navbarWithName: false,
    }
  },
  watch: {
    '$route.name': {
      immediate: true,
      handler(newVal) {
        if (newVal == "Generative AI") {
          document.documentElement.style.overflowY = 'hidden';
          document.documentElement.style.overflowX = 'hidden';
          document.body.style.overflowY = 'hidden';
          document.body.style.overflowX = 'hidden';
          document.documentElement.style.height = '100%';
          document.body.style.height = '100%';
          document.documentElement.style.margin = '0';
          document.body.style.margin = '0';
          document.documentElement.style.padding = '0';
          document.body.style.padding = '0';
        } else {
          document.documentElement.style.overflowY = '';
          document.body.style.overflowY = '';
          document.documentElement.style.height = '';
          document.body.style.height = '';
          document.documentElement.style.margin = '';
          document.body.style.margin = '';
          document.documentElement.style.padding = '';
          document.body.style.padding = '';
        }
      }
    }
  },
  methods: {
    ...mapMutations(['setNavbarWithName']),

    updateNavbarWithName(value) {
      this.setNavbarWithName(value);
    }
  }
}
</script>